export default "__VITE_ASSET__ef90a321__"